import { useRecoilValue } from 'recoil';
import { useExtraActions, useLoginActions } from '_actions';
import { paymentsAtom, userAtom } from '_state';
import { useEffect } from 'react';

export { Home };

function Home() {
    const user = useRecoilValue(userAtom);
    const loginActions = useLoginActions();
    const extraActions = useExtraActions();
    const payments = useRecoilValue(paymentsAtom);

    useEffect(() => {
        extraActions.getAllPayments(user);

        return extraActions.resetPayments;
    }, []);

    return (
        <main>
            <div className='bd-masthead'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-8 mx-auto text-center'>
                            <img src={`${process.env.PUBLIC_URL}/logo_solo.png`} alt="logo" />
                            <h1 className='mb-3 pb-3 fw-semibold'>Tu factura ya está lista para su descarga</h1>
                            <p className='mb-5 pb-5 lead'>Realiza tus facturas en tiempo y forma. El servicio de Facturación Electrónica es para tí. ¡Úsalo!</p>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-4 offset-md-2 text-center'>
                            <a download={`${user?.uuid}.pdf`} href={`data:application/pdf;base64,${user?.pdf}`}>
                                <img src='./pdf.png' className='img-fluid' />
                            </a>
                        </div>
                        <div className='col-md-4 text-center'>
                            <a download={`${user?.uuid}.xml`} href={`data:application/xml;base64,${user?.xml}`}>
                                <img src='./xml.png' className='img-fluid' />
                            </a>
                        </div>
                    </div>
                    {payments &&
                        <div className='row'>
                            <div className='col-md-12'>
                                <br />
                                <h2 className='text-center'>Complementos de pago</h2>
                                {payments?.map(payment =>
                                    <div className='row mb-3'>
                                        <div className='col-md-4 offset-md-2 text-center'>
                                            <a download={`${payment?.uuid}.pdf`} href={`data:application/pdf;base64,${payment?.pdf}`}>
                                                <img src='./pdf.png' className='img-fluid' />
                                            </a>
                                        </div>
                                        <div className='col-md-4 text-center'>
                                            <a download={`${payment?.uuid}.xml`} href={`data:application/xml;base64,${payment?.xml}`}>
                                                <img src='./xml.png' className='img-fluid' />
                                            </a>
                                        </div>
                                    </div>                                    
                                )}
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className='col-md-12 text-center mt-5'>
                            <button className="btn btn-primary mt-2" type='button' onClick={loginActions.logout}>
                                Ya descargué mis facturas, cerrar sesión
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
